// @flow

import React from 'react';
import Loadable from 'react-loadable';
import LoadingPage from './LoadingPage';
import { Route } from 'react-router-dom';

type Props = {
  loader: () => Promise<void>,
};

export default class LoadableRoute extends React.Component<Props> {
  loadableComponent: React$ComponentType<*>;

  constructor(props: Props, context: void) {
    super(props, context);

    // cache this to avoid remounting the subtree when navigating
    this.loadableComponent = Loadable({
      loader: props.loader,
      loading: LoadingPage,
      delay: 200,
    });
  }

  render() {
    const { ...props } = this.props;

    return <Route {...props} component={this.loadableComponent} />;
  }
}
